import axios from "axios";

export const getFilterFields = async (url) => {
  const apiUrl = `${process.env.EJ_APPS_API_HOSTNAME}/e6t/v2/listing/filter/fields/slug${url}`;

  const response = await axios.get(apiUrl);

  return response.data;
};

export const getRadarFilterFields = async () => {
  const apiUrl = `${process.env.EJ_APPS_API_HOSTNAME}/e6t/v1/project/filter/fields?categoryId=2&tradeTypeId=2`;

  const response = await axios.get(apiUrl);

  return response.data;
};

export const getCompanies = async () => {
  return axios
    .get(`${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/project/companies`)
    .then((response) => response)
    .catch((error) => error.response.data);
};
